import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../../app/services/shared/interfaces';

import { AppContext } from '../../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../../components/LazyLoading';

import ButtonCancelForm from '../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';

import { Provision } from '../../../../app/models/Provision';
import useProvisionService from '../../../../app/services/hooks/useProvisionService';
import ProvisionForm from '../forms/ProvisionForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ProvisionCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [provision, setProvision] = useState<Provision>({ name: '' });

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreProvision, storeProvision } = useProvisionService();

    // useEffect(() => {

    // }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando previsión...');
        storeProvision(provision, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <ProvisionForm
                        provisionDataForm={provision}
                        setProvisionDataForm={setProvision}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreProvision} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreProvision} />
                </div>
            </div>
        </>
    );
};

export default ProvisionCreate;
